// import { IS_LOCAL, MEDIA_URL } from "@/app/clients/alma/constants";
import { cn } from "@pulsex/utils";

import pulseConfig from "@/pulsex.config";
import { MangoXImage } from "@pulsex/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { CSSProperties } from "react";

type ImageProps = {
    data: any;
    forceCrop?: string;
    cropSize?: string;
    className?: string;
    style?: CSSProperties;
    imageRatio?: number;
    needsMediaURL?: boolean;
    isVideo?: boolean;
    ImageElementClassName?: string;
    resolution?: number;
    useReelImage?: boolean;
};

const ImageUI = ({
    data,
    forceCrop,
    isVideo,
    imageRatio,
    className,
    cropSize = "square",
    style,
    needsMediaURL = false,
    ImageElementClassName,
    resolution = 1,
    useReelImage = false,
}: ImageProps) => {
    return (
        <>
            <MangoXImage
                config={pulseConfig}
                data={data ? data : "/default1.webp"}
                forceCrop={forceCrop}
                cropSize={cropSize}
                useReelImage={useReelImage}
                className={cn("w-full block rounded-md", className)}
                style={style}
                resolution={resolution}
                imageRatio={imageRatio}
                needsMediaURL={needsMediaURL}
                ImageElementclassName={ImageElementClassName}
            >
                {isVideo && (
                    <div className="z-10 bg-blueLight absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full h-12 w-12 flex justify-center items-center lg:w-7 lg:h-7">
                        <FontAwesomeIcon
                            icon={faPlay}
                            className="text-white lg:text-xs"
                        />
                    </div>
                )}
            </MangoXImage>
        </>
    );
};

export default ImageUI;
